import { render, staticRenderFns } from "./ParticipantsCard.vue?vue&type=template&id=1cccbbb8&scoped=true"
import script from "./ParticipantsCard.vue?vue&type=script&lang=js"
export * from "./ParticipantsCard.vue?vue&type=script&lang=js"
import style0 from "./ParticipantsCard.vue?vue&type=style&index=0&id=1cccbbb8&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cccbbb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cccbbb8')) {
      api.createRecord('1cccbbb8', component.options)
    } else {
      api.reload('1cccbbb8', component.options)
    }
    module.hot.accept("./ParticipantsCard.vue?vue&type=template&id=1cccbbb8&scoped=true", function () {
      api.rerender('1cccbbb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/ParticipantsCard.vue"
export default component.exports